module.exports = require('./valid')


//////////////////
// WEBPACK FOOTER
// ./src/mock/valid/index.js
// module id = 25
// module chunks = 0